import { mapState } from 'vuex'
import LocalePicker from '@/components/common/localepicker/LocalePicker.vue'

export default {
  name: 'SingleFileupload',
  props: {
    value: Object | Array,
    disabled: {
      type: Boolean,
      default: false
    },
    changelocale: {
      type: Boolean,
      default: false
    },
    includeDoctype: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    singleline: {
      type: Boolean,
      default: false
    },
    includeTitle: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String,
      default: null
    },
    imageUpload: {
      type: Boolean,
      default: false
    },
    maxFilesize: {
      type: Number,
      default: 10
    },
    displayPreview: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      content: (this.value === null) ? { title: '', locale: null, document_type: null, file: null } : this.setValueParams(this.value),
      selectedLocale: null
    };
  },
  components: {
    LocalePicker
  },
  computed: {
    ...mapState(['config']),
    documentTypeOptions () {
      const options = this.$store.getters.getConfigOptions('document_types', this.$i18n.locale);
      options.unshift({ code: null, text: '' });
      return options;
    },
    getFileTitle () {
      if (this.imageUpload) {
        return this.$t('general.file.image', { size: this.maxFilesize });
      }
      return this.$t('general.file.file', { size: this.maxFilesize });
    },
    getFileClass () {
      if (this.singleline) {
        if (this.includeDoctype && this.changelocale) {
          return 'col-lg-4 col-md-12'
        }
        if (this.includeTitle) {
          return 'col-lg-6 col-md-12';
        }
        return 'col-lg-12 col-md-12';
      }
      if (this.includeDoctype) {
        return 'col-md-12';
      } else if (this.changelocale) {
        return 'col-lg-4 col-md-12'
      }
      return 'col-lg-6 col-md-12';
    },
    getFileAccept () {
      if (this.accept) {
        return this.accept;
      } else if (this.imageUpload) {
        return 'image/*';
      }
      return '';
    }
  },
  methods: {
    updateFile () {
      const files = this.$refs.fileupload.$refs.input.files;
      if (files && files.length > 0) {
        const file = files[0];
        if (file.size > (1024 * 1024 * this.maxFilesize)) {
          this.content.base64 = '';
          this.$refs.fileupload.reset();
          this.clearFile();
          this.$bvModal.msgBoxOk(this.$t('general.file.size-error', { size: this.maxFilesize }), {
            title: [this.$t('general.error')],
            noFade: true,
            okTitle: this.$t('general.ok')
          });
        } else {
          if (this.imageUpload) {
            const reader = new FileReader();
            const self = this;
            reader.addEventListener('load', function () {
              self.content.base64 = reader.result;
              self.updateValue();
              self.$forceUpdate();
            }, false);
            if (file) {
              reader.readAsDataURL(file);
            }
          } else {
            this.updateValue();
            this.$forceUpdate();
          }
        }
      } else {
        this.content.base64 = '';
      }
      this.updateValue();
    },
    updateValue () {
      this.$emit('input', this.content)
      this.$emit('changed', this.content)
    },
    clearFile () {
      this.content.filename = null;
      this.updateValue();
    },
    openFileupload () {
      this.$refs.fileupload.$refs.input.click()
    },
    setValueParams (val) {
      if (val.document_type_id !== null) {
        val.document_type = this.$store.getters.getParamFromConfig('document_types', val.document_type_id, 'code');
      } else {
        val.document_type = null;
      }
      return val;
    }
  }
}
